import React from 'react';
import {  useLocation } from 'react-router-dom';
//import { ChevronRight } from 'lucide-react';

const GettingStarted = () => {
  const location = useLocation();
  const currentHash = location.hash.replace('#', '');

  const sections = [
    {
      id: 'hesap-olusturma',
      title: 'Hesap Oluşturma',
      summary: 'Smart Portfolio hesabınızı nasıl oluşturacağınızı öğrenin.',
      content: 'Hesap oluşturma adımları...',
      image: '/images/docs/account-creation.png'
    },
    {
      id: 'ilk-portfoyunuzu-olusturma',
      title: 'İlk Portföyünüzü Oluşturma',
      summary: 'Portföy oluşturma ve varlık ekleme işlemleri',
      content: 'Portföy oluşturma adımları...',
      image: '/images/docs/portfolio-creation.png'
    }
    // ...other sections
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0E23] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Summary Section */}
        <div className="mb-12 p-6 bg-blue-50 dark:bg-blue-900/20 rounded-xl">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Başlarken
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Smart Portfolio'yu kullanmaya başlamak için temel adımları öğrenin.
          </p>
        </div>

        {/* Content Navigation */}
        <div className="grid grid-cols-12 gap-8">
          {/* Left Sidebar */}
          <nav className="col-span-3">
            <div className="sticky top-24">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">
                İçindekiler
              </h3>
              <ul className="space-y-2">
                {sections.map((section) => (
                  <li key={section.id}>
                    <a
                      href={`#${section.id}`}
                      className={`block px-3 py-2 rounded-lg text-sm ${
                        currentHash === section.id
                          ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400'
                          : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800/50'
                      }`}
                    >
                      {section.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Main Content */}
          <div className="col-span-9">
            {sections.map((section) => (
              <div
                key={section.id}
                id={section.id}
                className="mb-16 scroll-mt-24"
              >
                <div className="grid grid-cols-2 gap-8">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                      {section.title}
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mb-4">
                      {section.summary}
                    </p>
                    <div className="prose dark:prose-invert max-w-none">
                      {section.content}
                    </div>
                  </div>
                  <div>
                    <img
                      src={section.image}
                      alt={section.title}
                      className="rounded-lg shadow-lg"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;